import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useApp from '@/pages/App.context';
import getMenuSign from '@/pages/menuSign';
import Dropdown from '@/components/Navigation/Dropdown';
import Languages from './Languages';
import SCircle from '@/assets/logo/SCircle.svg?react';
import Swipesign from '@/assets/logo/Swipesign.svg?react';
import styles from './SignHeader.module.scss';

const SignHeader = () => {
  const { additionalData } = useApp();
  const { i18n } = useTranslation();

  return (
    <header className={styles.header}>
      <Link to="/dashboard" className={styles.home}>
        <SCircle className={styles.s} />
        <Swipesign className={styles.logo} />
      </Link>
      <div className={styles.additionalData}>{additionalData}</div>
      <Dropdown
        align="right"
        popover="right bottom"
        menuItems={getMenuSign(i18n.language ?? 'en')}
        className={{ hamburger: styles.hamburger, content: styles.dropdown }}
      />
      <Languages />
    </header>
  );
};

export default SignHeader;
